<template>
    <div class="container-fluid blacklists">
        <v-title :lineage="[{'Automations':'automations'}]">
            Blacklists
            <div slot="actions">
                <router-link
                    v-if="$auth.$pages['add-blacklist'].isAllowed"
                    :to="{name: 'add-blacklist', params: {type}}"
                    class="btn btn-link">Add Blacklist Item<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
            </div>
        </v-title>
        <div class="grid">
            <div class="grid-item">
                <div class="tile">
                    <r-tabs :divided="true" content-class="no-padding" menu-class="no-margin-bottom">
                        <r-tab name="Emails"
                            :to="{name: 'blacklists', params: {type: 'email'}}">
                            <grid
                                class="no-box-shadow"
                                :columns="defaultColumns('emails')"
                                :provider="getProvider('email')"
                                @completed="stopLoadingPage"
                                :show-column-options="false"
                            >
                                <v-no-content slot="no-content">
                                    <span slot="title">It seems that you have no blacklist items</span>
                                    <p slot="description">
                                        Create a new blacklist item for emails
                                    </p>
                                    <div slot="actions">
                                        <router-link
                                            v-if="$auth.$pages['add-blacklist'].isAllowed"
                                            :to="{name: 'add-blacklist', params: {type: 'email'}}"
                                            class="btn btn-link">Add Blacklist Item<v-icon class="margin-left-xs" icon="arrow-right"/>
                                        </router-link>
                                    </div>
                                </v-no-content>
                            </grid>
                        </r-tab>
                        <r-tab name="Email Domains"
                               :to="{name: 'blacklists', params: {type: 'email-domain'}}">
                            <grid
                                class="no-box-shadow"
                                :columns="defaultColumns('email-domain')"
                                :provider="getProvider('email-domain')"
                                @completed="stopLoadingPage"
                                :show-column-options="false"
                            >
                                <v-no-content slot="no-content">
                                    <span slot="title">It seems that you have no blacklist items</span>
                                    <p slot="description">
                                        Create a new blacklist item for email domains
                                    </p>
                                    <div slot="actions">
                                        <router-link
                                            v-if="$auth.$pages['add-blacklist'].isAllowed"
                                            :to="{name: 'add-blacklist', params: {type: 'email-domain'}}"
                                            class="btn btn-link">Add Blacklist Item<v-icon class="margin-left-xs" icon="arrow-right"/>
                                        </router-link>
                                    </div>
                                </v-no-content>
                            </grid>
                        </r-tab>
                        <r-tab name="IP Address"
                               :to="{name: 'blacklists', params: {type: 'ip-address'}}">
                            <grid
                                class="no-box-shadow"
                                :columns="defaultColumns('ip-address')"
                                :provider="getProvider('ip-address')"
                                :show-column-options="false"
                            >
                                <v-no-content slot="no-content">
                                    <span slot="title">It seems that you have no blacklist items</span>
                                    <p slot="description">
                                        Create a new blacklist item for ip address
                                    </p>
                                    <div slot="actions">
                                        <router-link
                                            v-if="$auth.$pages['add-blacklist'].isAllowed"
                                            :to="{name: 'add-blacklist', params: {type: 'ip-address'}}"
                                            class="btn btn-link">Add Blacklist Item<v-icon class="margin-left-xs" icon="arrow-right"/>
                                        </router-link>
                                    </div>
                                </v-no-content>
                            </grid>
                        </r-tab>
                        <r-tab name="BINs"
                               :to="{name: 'blacklists', params: {type: 'bin'}}">
                            <grid
                                class="no-box-shadow"
                                :columns="defaultColumns('bin')"
                                :provider="getProvider('bin')"
                                :show-column-options="false"
                            >
                                <v-no-content slot="no-content">
                                    <span slot="title">It seems that you have no blacklist items</span>
                                    <p slot="description">
                                        Create a new blacklist item for bins
                                    </p>
                                    <div slot="actions">
                                        <router-link
                                            v-if="$auth.$pages['add-blacklist'].isAllowed"
                                            :to="{name: 'add-blacklist', params: {type: 'bin'}}"
                                            class="btn btn-link">Add Blacklist Item<v-icon class="margin-left-xs" icon="arrow-right"/>
                                        </router-link>
                                    </div>
                                </v-no-content>
                            </grid>
                        </r-tab>
                        <r-tab name="Customer IDs"
                               :to="{name: 'blacklists', params: {type: 'customer-id'}}">
                            <grid
                                class="no-box-shadow"
                                :columns="defaultColumns('customer-id')"
                                :provider="getProvider('customer-id')"
                                :show-column-options="false"
                            >
                                <v-no-content slot="no-content">
                                    <span slot="title">It seems that you have no blacklist items</span>
                                    <p slot="description">
                                        Create a new blacklist item for customers
                                    </p>
                                    <div slot="actions">
                                        <router-link
                                            v-if="$auth.$pages['add-blacklist'].isAllowed"
                                            :to="{name: 'add-blacklist', params: {type: 'customer-id'}}"
                                            class="btn btn-link">Add Blacklist Item<v-icon class="margin-left-xs" icon="arrow-right"/>
                                        </router-link>
                                    </div>
                                </v-no-content>
                            </grid>
                        </r-tab>
                        <r-tab name="Countries"
                               :to="{name: 'blacklists', params: {type: 'country'}}">
                            <grid
                                class="no-box-shadow"
                                :columns="defaultColumns('country')"
                                :provider="getProvider('country')"
                                :show-column-options="false"
                            >
                                <v-no-content slot="no-content">
                                    <span slot="title">It seems that you have no blacklist items</span>
                                    <p slot="description">
                                        Create a new blacklist item for countries
                                    </p>
                                    <div slot="actions">
                                        <router-link
                                            v-if="$auth.$pages['add-blacklist'].isAllowed"
                                            :to="{name: 'add-blacklist', params: {type: 'country'}}"
                                            class="btn btn-link">Add Blacklist Item<v-icon class="margin-left-xs" icon="arrow-right"/>
                                        </router-link>
                                    </div>
                                </v-no-content>
                            </grid>
                        </r-tab>
                        <r-tab name="Fingerprints"
                               :to="{name: 'blacklists', params: {type: 'fingerprint'}}">
                            <grid
                                class="no-box-shadow"
                                :columns="defaultColumns('fingerprint')"
                                :provider="getProvider('fingerprint')"
                                :show-column-options="false"
                            >
                                <v-no-content slot="no-content">
                                    <span slot="title">It seems that you have no blacklist items</span>
                                    <p slot="description">
                                        Create a new blacklist item for fingerprints
                                    </p>
                                    <div slot="actions">
                                        <router-link
                                            v-if="$auth.$pages['add-blacklist'].isAllowed"
                                            :to="{name: 'add-blacklist', params: {type: 'fingerprint'}}"
                                            class="btn btn-link">Add Blacklist Item<v-icon class="margin-left-xs" icon="arrow-right"/>
                                        </router-link>
                                    </div>
                                </v-no-content>
                            </grid>
                        </r-tab>
                        <r-tab name="Payment Cards"
                               :to="{name: 'blacklists', params: {type: 'payment-card'}}">
                            <grid
                                class="no-box-shadow"
                                :columns="defaultColumns('payment-card')"
                                :provider="getProvider('payment-card')"
                                :show-column-options="false"
                            >
                                <v-no-content slot="no-content">
                                    <span slot="title">It seems that you have no blacklist items</span>
                                    <p slot="description">
                                        Create a new blacklist item for payment cards
                                    </p>
                                    <div slot="actions">
                                        <router-link
                                            v-if="$auth.$pages['add-blacklist'].isAllowed"
                                            :to="{name: 'add-blacklist', params: {type: 'payment-card'}}"
                                            class="btn btn-link">Add Blacklist Item<v-icon class="margin-left-xs" icon="arrow-right"/>
                                        </router-link>
                                    </div>
                                </v-no-content>
                            </grid>
                        </r-tab>
                        <r-tab name="Bank Accounts"
                               :to="{name: 'blacklists', params: {type: 'bank-account'}}">
                            <grid
                                class="no-box-shadow"
                                :columns="defaultColumns('bank-account')"
                                :provider="getProvider('bank-account')"
                                :show-column-options="false"
                            >
                                <v-no-content slot="no-content">
                                    <span slot="title">It seems that you have no blacklist items</span>
                                    <p slot="description">
                                        Create a new blacklist item for bank accounts
                                    </p>
                                    <div slot="actions">
                                        <router-link
                                            v-if="$auth.$pages['add-blacklist'].isAllowed"
                                            :to="{name: 'add-blacklist', params: {type: 'bank-account'}}"
                                            class="btn btn-link">Add Blacklist Item<v-icon class="margin-left-xs" icon="arrow-right"/>
                                        </router-link>
                                    </div>
                                </v-no-content>
                            </grid>
                        </r-tab>
                        <r-tab name="Address"
                               :to="{name: 'blacklists', params: {type: 'address'}}">
                            <grid
                                class="no-box-shadow"
                                :columns="defaultColumns('address')"
                                :provider="getProvider('address')"
                                :show-column-options="false"
                            >
                                <v-no-content slot="no-content">
                                    <span slot="title">It seems that you have no blacklist items</span>
                                    <p slot="description">
                                        Create a new blacklist item for an address
                                    </p>
                                    <div slot="actions">
                                        <router-link
                                            v-if="$auth.$pages['add-blacklist'].isAllowed"
                                            :to="{name: 'add-blacklist', params: {type: 'address'}}"
                                            class="btn btn-link">Add Blacklist Item<v-icon class="margin-left-xs" icon="arrow-right"/>
                                        </router-link>
                                    </div>
                                </v-no-content>
                            </grid>
                        </r-tab>
                    </r-tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import {vIcon} from '@/components/form';
    import vNoContent from '@/components/v-no-content';
    import _ from '@/common/helpers';
    import Grid from '@/components/grid/grid';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import ColumnSet from '@/components/grid/columns/column-set';
    import {createDialog, vConfirm} from '@/components/modal/dialogs';

    export default {
        identifier: 'blacklists',
        components: {
            vTitle, Grid, vNoContent, vIcon,
        },
        mixins: [LoadStateMixin],
        props: {
            type: {
                type: String,
                required: false,
                default: 'email',
            },
        },
        methods: {
            async showDeleteBlacklistItemDialog(data, grid) {
                const confirmDialog = createDialog(vConfirm, this);
                const dialogParams = {
                    title: 'Delete Blacklist Item',
                    content: 'Are you sure you want to delete this item?',
                    confirmLabel: 'Delete',
                    dangerConfirm: true,
                };
                if (await confirmDialog(dialogParams)) {
                    this.deleteBlacklistField(data, grid);
                }
            },
            async deleteBlacklistField(data, grid) {
                try {
                    const params = {
                        id: data.fields.id,
                    };
                    grid.startLoading();
                    await this.$api(({blacklists}) => blacklists.delete(params));
                    grid.fetchData();
                    this.$toast.positive('Blacklist successfully deleted');
                } catch (error) {
                    this.$toast.fromError(error, 'Something went wrong, please contact support');
                    grid.stopLoading();
                }
            },
            formatHeader(resourceType) {
                if (resourceType === 'payment-card') {
                    return 'Payment Card Fingerprint';
                }
                if (resourceType === 'bank-account') {
                    return 'Bank Account Fingerprint';
                }
                return _.unKebabCase(resourceType);
            },
            defaultColumns(resourceType) {
                return new ColumnSet({
                    id: `bl-${resourceType}-list`,
                    store: this.$store,
                    version: 1,
                    defaultColumns: [
                        {
                            header: this.formatHeader(resourceType),
                            name: 'value',
                            sortable: true,
                        },
                        {
                            header: 'expires on',
                            type: 'datetime',
                            name: 'expirationTime',
                            sortable: true,
                        },
                    ],
                    lockedColumns: [
                        {
                            header: false,
                            type: 'button',
                            style: {
                                preset: 'delete',
                            },
                            click: ({rowData, grid}) => {
                                this.showDeleteBlacklistItemDialog(rowData, grid);
                            },
                        },
                    ],
                });
            },
            getProvider(type) {
                return params => this.$api(({blacklists}) => blacklists.getAll({...params, filter: `type:${type}`}));
            },
        },
    };
</script>
